import useMediaQuery from '@mui/material/useMediaQuery';

// Same breakpoints as the media queries at the end of App.css
export const PHONE_QUERY = '(max-width: 599.95px)';
export const TABLET_QUERY = '(min-width: 600px) and (max-width: 1199.95px)';

// isPhone: narrow screens, where the overlays are docked at the bottom of the map
// isTablet: tablets (and phones in landscape), where the overlays keep floating but with adapted sizes
export default function useIsMobile() {
    const isPhone = useMediaQuery(PHONE_QUERY);
    const isTablet = useMediaQuery(TABLET_QUERY);
    return {isPhone, isTablet};
}
